import React from "react";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { Icon } from "@mui/material";
import { Checkbox, Tooltip } from "@gpstrackit/gtc-react-controls";
import { HasPermission } from "Core/security";

const stopLabelToggle = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

export const PrivateClipRequest = ({ checked, setChecked, ...rest }) => {
  const userSecurity = useSelector((state) => state.securityRedux.user);
  const { messages } = useIntl();

  const tooltipText = messages["video_privatecliprequest_tooltip"];

  if (!HasPermission(userSecurity, ["privatecliprequest"], [372])) {
    return null;
  }

  return (
    <Checkbox
      label={
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <span>{messages["video_privatecliprequest"]}</span>
          <Tooltip title={tooltipText}>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                lineHeight: 0,
                cursor: "help",
              }}
              onClick={stopLabelToggle}
              onMouseDown={stopLabelToggle}
            >
              <Icon
                aria-label={tooltipText}
                style={{ fontSize: 14, opacity: 0.72 }}
                tabIndex={0}
              >
                help_outline
              </Icon>
            </span>
          </Tooltip>
        </span>
      }
      checked={checked}
      onChange={(value) => setChecked(value)}
      {...rest}
    />
  );
};
